import React, { createRef, forwardRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import Button from '@material-ui/core/Button';
import { getSessionStorageItem, SESSION_STORAGE_NEEDS_ANALYSIS_KEY } from '../../../sessionStorage';
import NumberFormat from 'react-number-format';
import '../InsuranceTools.scss';

export default function PrintNeedsAnalysis(props) {

    const printRef = createRef();

    const handlePrint = useReactToPrint({
        copyStyles: true,
        content: () => printRef.current,
    });
   
    return (
        <div>
            <Button variant="contained" size="medium" className='float-right mr-2 start-over-btn' color="primary" onClick={handlePrint}>
                PRINT ALL
            </Button>

            <div className="d-none">
                <ComponentToPrint ref={printRef} />
            </div>
        </div>
    )
}

const QuoteResult = (props) => {
    return (
        <React.Fragment>
            <tr>
                <td>
                    <p></p>
                    <h4><b>{props.name}</b></h4>
                    {props.longText}
                    <p></p>
                    {props.coverage ? <React.Fragment>Amount: <NumberFormat displayType={'text'} prefix={'$'} value={props.coverage} thousandSeparator={true} /></React.Fragment> : null}
                </td>
            </tr>
            {props.shortText &&
                <tr>
                    <td colspan="4">
                        {props.shortText}
                    </td>
                </tr>
            }
        </React.Fragment>
    )
}

const ComponentToPrint = forwardRef((props, ref) => {

    let sessionObj = getSessionStorageItem(SESSION_STORAGE_NEEDS_ANALYSIS_KEY);
    const personalInfo = sessionObj && sessionObj.pages && sessionObj.pages.clientBasicInfo;
    const financialInfo = sessionObj && sessionObj.pages && sessionObj.pages.financialInfo;
    const currentInsuranceInfo = sessionObj && sessionObj.pages && sessionObj.pages.currentInsurance;
    const additionalClientInfo = sessionObj && sessionObj.pages && sessionObj.pages.additionalClientInfo;
    const monthlyExpenses = sessionObj && sessionObj.pages && sessionObj.pages.monthlyExpenses;
    const quoterData = sessionObj && sessionObj.pages && sessionObj.pages.quoter;

    return (
        <div ref={ref} className="pt-4 print-document">
            {sessionObj !== null &&
                <table>
                    <tbody>
                        <tr><td colspan="2"><h1><b>Morgan Stanley</b></h1></td></tr><br />
                        <tr><td colspan="2"></td></tr>
                        <tr><td colspan="2"><h2><b>Client's Personal Information</b></h2></td></tr>
                        <tr>
                            <td colspan="2">Age:</td>
                            <td colspan="2" class="rightColumn">{parseInt(personalInfo.clientAge, 10)}</td>
                        </tr>
                        <tr>
                            <td colspan="2">Gender:</td>
                            <td colspan="2" class="rightColumn">{personalInfo.clientGender === "M" ? "Male" : "Female"}</td>
                        </tr>
                        <tr>
                            <td colspan="2">Resident State:</td>
                            <td colspan="2" class="rightColumn">{personalInfo.clientState}</td>
                        </tr>
                        <tr>
                            <td colspan="2">Marital Status:</td>
                            <td colspan="2" class="rightColumn">{personalInfo.maritalStatus}</td>
                        </tr>
                        <tr> <td colspan="2"></td></tr><br />
                        <tr>
                            <td colspan="2">
                                <h2><b>Client's Financial Information</b></h2>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <h3>Income</h3>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">&nbsp;&nbsp;&nbsp; Client's Annual Income:</td>
                            <td colspan="2" class="rightColumn"><NumberFormat displayType={'text'} prefix={'$'} value={financialInfo.mainIncome} thousandSeparator={true} /></td>
                        </tr>

                        {personalInfo.maritalStatus === "Married" &&
                            <tr>
                                <td colspan="2">&nbsp;&nbsp;&nbsp; Client's Spouse Annual Income:</td>
                                <td colspan="2" class="rightColumn"><NumberFormat displayType={'text'} prefix={'$'} value={financialInfo.spouseIncome} thousandSeparator={true} /></td>
                            </tr>
                        }

                        <tr>
                            <td colspan="2">&nbsp;&nbsp;&nbsp; Client's Other Annual Income: </td>
                            <td colspan="2" class="rightColumn"><NumberFormat displayType={'text'} prefix={'$'} value={financialInfo.otherIncome} thousandSeparator={true} /></td>
                        </tr>

                        <tr>
                            <td colspan="2">
                                <h3>Assets</h3>
                            </td>
                        </tr>

                        <tr>
                            <td colspan="2">&nbsp;&nbsp;&nbsp; Client's Liquid Assets:</td>
                            <td colspan="2" class="rightColumn"><NumberFormat displayType={'text'} prefix={'$'} value={financialInfo.liquidAssets} thousandSeparator={true} /></td>

                        </tr>

                        <tr>
                            <td colspan="2">&nbsp;&nbsp;&nbsp; Client's Retirement Assets:</td>
                            <td colspan="2" class="rightColumn"><NumberFormat displayType={'text'} prefix={'$'} value={financialInfo.retirementAssets} thousandSeparator={true} /></td>
                        </tr>

                        <tr>
                            <td colspan="2">&nbsp;&nbsp;&nbsp; Client's Other Assets: </td>
                            <td colspan="2" class="rightColumn"><NumberFormat displayType={'text'} prefix={'$'} value={financialInfo.otherAssets} thousandSeparator={true} /></td>
                        </tr>

                        <tr>
                            <td colspan="2"><h3>Liabilities</h3></td>
                        </tr>

                        <tr>
                            <td colspan="2">&nbsp;&nbsp;&nbsp; Client's Mortgage Balance: </td>
                            <td colspan="2" class="rightColumn"><NumberFormat displayType={'text'} prefix={'$'} value={financialInfo.mortgage} thousandSeparator={true} /></td>
                        </tr>

                        <tr>
                            <td colspan="2">&nbsp;&nbsp;&nbsp; Client's Other Total Debt: </td>
                            <td colspan="2" class="rightColumn"><NumberFormat displayType={'text'} prefix={'$'} value={financialInfo.debt} thousandSeparator={true} /></td>
                        </tr><br />

                        <tr>
                            <td colspan="2"><h2><b>Client's Current Insurance</b></h2></td>
                        </tr>

                        <tr>
                            <td colspan="2">Does your client currently have a life insurance policy?</td>
                            <td colspan="2" class="rightColumn">{currentInsuranceInfo.hasExistingPolicy === "no" ? "No" : "Yes"}</td>
                        </tr>

                        {currentInsuranceInfo.hasExistingPolicy === "yes" &&
                            <tr>
                                <td colspan="2">Current coverage amount</td>
                                <td colspan="2" class="rightColumn"><NumberFormat displayType={'text'} prefix={'$'} value={currentInsuranceInfo.existingLifePolicyCoverage} thousandSeparator={true} /></td>
                            </tr>
                        }

                        <tr>
                            <td colspan="2">Does your client currently have a disability insurance policy?</td>
                            <td colspan="2" class="rightColumn">{currentInsuranceInfo.hasExistingDIPolicy === "no" ? "No" : "Yes"}</td>
                        </tr>

                        {currentInsuranceInfo.hasExistingDIPolicy === "yes" &&
                            <tr>
                                <td colspan="2">Current monthly coverage</td>
                                <td colspan="2" class="rightColumn"><NumberFormat displayType={'text'} prefix={'$'} value={currentInsuranceInfo.existingDIPolicyCoverage} thousandSeparator={true} /></td>
                            </tr>
                        }

                        <tr>
                            <td colspan="2">Does your client currently have a long-term care policy?  </td>
                            <td colspan="2" class="rightColumn">{currentInsuranceInfo.hasExistingLTCPolicy === "no" ? "No" : "Yes"}</td>
                        </tr>

                        {currentInsuranceInfo.hasExistingLTCPolicy === "yes" &&
                            <tr>
                                <td colspan="2">Current monthly coverage</td>
                                <td colspan="2" class="rightColumn"><NumberFormat displayType={'text'} prefix={'$'} value={currentInsuranceInfo.existingLTCPolicyCoverage} thousandSeparator={true} /></td>
                            </tr>
                        }

                        {financialInfo.hasMonthlyExpensesStep && personalInfo.needsDI &&
                            <React.Fragment>
                                <br />
                                <tr>
                                    <td colspan="2"><h2><b>Client's Monthly Expenses</b></h2></td>
                                </tr>

                                <tr>
                                    <td colspan="2">Client's Mortgage Balance:</td>
                                    <td colspan="2" class="rightColumn"><NumberFormat displayType={'text'} prefix={'$'} value={monthlyExpenses.mortgageExpense} thousandSeparator={true} /></td>
                                </tr>

                                <tr>
                                    <td colspan="2">Client's Essential Expense: </td>
                                    <td colspan="2" class="rightColumn"><NumberFormat displayType={'text'} prefix={'$'} value={monthlyExpenses.additionalExpense} thousandSeparator={true} /></td>
                                </tr>

                                <tr>
                                    <td colspan="2">Client's Non-Essential Expense: </td>
                                    <td colspan="2" class="rightColumn"><NumberFormat displayType={'text'} prefix={'$'} value={monthlyExpenses.nonEssentialExpense} thousandSeparator={true} /></td>
                                </tr>
                            </React.Fragment>
                        }

                        <br />
                        {financialInfo.hasAdditionalClientInfoStep && personalInfo.needsLife &&
                            <React.Fragment>
                                <tr>
                                    <td colspan="2"><h2><b>Additional Client Information</b></h2></td>
                                </tr>

                                <tr>
                                    <td colspan="2">Policy Length (Years):</td>
                                    <td colspan="2" class="rightColumn">{additionalClientInfo.lifeReplacementYears}</td>
                                </tr>

                                <tr>
                                    <td colspan="2">Education Expense:</td>
                                    <td colspan="2" class="rightColumn"><NumberFormat displayType={'text'} prefix={'$'} value={additionalClientInfo.collegeExpense} thousandSeparator={true} /></td>
                                </tr>
                            </React.Fragment>
                        }
                        <br />
                        <tr>
                            <td colspan="2"><h2><b>Client's Product Advice</b></h2></td>
                        </tr>

                        {
                            personalInfo.needsLife === true &&
                            <QuoteResult
                                name='Term Life Insurance'
                                longText="In order to protect your client’s family's financial future, they need life insurance.  There are multiple options and we can guide you to the product that best meets your client's needs."
                                shortText="Recommended coverage is based on the required income replacement plus current and anticipated future liabilities minus existing life insurance."
                                coverage={quoterData.needsCoverageAmount}
                            />
                        }

                        {
                            personalInfo.needsDI === true &&
                            <QuoteResult
                                name='Disability Insurance'
                                longText="Disability insurance protects your client’s income in the event that they become disabled.  Although they may have enough savings to meet their short-term needs, they may not be able to sustain their living expenses if they are unable to work for months or years."
                                shortText="Recommended coverage is based on monthly expense minus spouse’s income, other income, and existing disability insurance coverage."
                                coverage={quoterData.needsDisabilityCoverageAmount}
                            />
                        }

                        {
                            personalInfo.needsFinalExpense === true &&
                            <QuoteResult
                                name='Final Expenses'
                                longText="Today, the average funeral costs between $7,000 and $10,000. This includes the services at the funeral home, burial in a cemetery and the a simple headstone.  To avoid the burden on your family, you can purchase an inexpensive final expense policy that can help cover these costs when you pass away."
                            />
                        }

                        {
                            personalInfo.needsLTC === true &&
                            <QuoteResult
                                name='Long-Term Care'
                                longText="Over 70 percent of Americans over the age of 65 will need long-term care services at some point. Long-term care insurance helps pay for personal care if your client is unable to care for themselves."
                            />
                        }

                        {
                            personalInfo.needsIncome === true &&
                            <QuoteResult
                                name='No income'
                                longText="Based on your client’s financial profile, Insurance Solutions may not be appropriate at this time."
                            />
                        }

                        {
                            personalInfo.needsLife !== true
                            && personalInfo.needsDI !== true
                            && personalInfo.needsFinalExpense !== true
                            && personalInfo.needsLTC !== true
                            && personalInfo.needsIncome !== true
                            && personalInfo.needsEstatePlanning !== true &&
                            <QuoteResult
                                name='You Are In Good Shape'
                                longText="Based on your age, financial information, existing insurance, and net worth, we currently do not have any specific products to advise."
                            />
                        }
                    </tbody>
                </table>
            }
        </div>
    )
})


// WEBPACK FOOTER //
// ./src/components/InsuranceTools/NeedsAnalysis/PrintNeedsAnalysis.js